"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @ignore */

/** */
// Ignore index from generated docs ^

var HostedModel_1 = require("./HostedModel");

exports.HostedModel = HostedModel_1.HostedModel;